<template>
  <div class="l-navbar" id="nav-bar">
    <div class="l-navbar-content">
      <!-- <router-link :to="{ name: 'course' }" class="side-link" @click="toggleSideBar">Program Dilatih</router-link> -->
      <div class="">
        <a
          class="collapse-toggle side-link d-flex align-items-center justify-content-between text-decoration-none"
          data-bs-toggle="collapse"
          href="#collapse_program"
          role="button"
          aria-expanded="false"
          aria-controls="collapse_program"
        >
          Program Dilatih
          <i class="fas fa-chevron-down" aria-hidden="true"></i>
        </a>
        <ul class="collapse text-start ps-4" id="collapse_program">
          <router-link
            :to="{ name: 'dilatih-insight' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            >Dilatih Insight</router-link
          >
          <router-link
            :to="{ name: 'dilatih-workshop' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            >Dilatih Workshop</router-link
          >
          <router-link
            :to="{ name: 'sertifikasi-bnsp' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            >Sertifikasi BNSP</router-link
          >
        </ul>
      </div>
      <router-link
        :to="{ name: 'in-house-training' }"
        class="side-link text-decoration-none"
        @click="toggleSideBar"
        >Untuk Perusahaan</router-link
      >
      <router-link
        :to="{ name: 'blog' }"
        class="side-link text-decoration-none"
        @click="toggleSideBar"
        >Blog</router-link
      >
      <router-link
        :to="{ name: 'about-us' }"
        class="side-link text-decoration-none"
        @click="toggleSideBar"
        >Tentang Kami</router-link
      >
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Swal from 'sweetalert2'
import { useToast } from 'vue-toastification'
import { useLoading } from 'vue-loading-overlay'
import { useRouter } from 'vue-router'

export default {
  name: 'SidebarAdminComponent',
  setup() {
    const router = useRouter()
    const toast = useToast()
    const $loading = useLoading({})
    const store = useStore()
    const route = useRoute()
    const data = reactive({
      route: '',
      isLogin: false,
    })

    const profile = computed(() => {
      return JSON.parse(window.localStorage.getItem('user'))
    })

    const logged = computed(() => {
      return window.localStorage.getItem('token')
    })

    const menu = computed(() => {
      return store.state.auth.menu
        ? store.state.auth.menu
        : JSON.parse(window.localStorage.getItem('menu'))
    })

    const ip = computed(() => {
      return window.localStorage.getItem('ip')
    })

    function toggleSideBar() {
      let toggler = document.querySelector('.sidebar-toggler')
      let nav = document.querySelector('.l-navbar')
      nav.classList.toggle('show')
      if (nav.className.includes('show')) {
        toggler.classList.add('sidebar-open')
      } else {
        toggler.classList.remove('sidebar-open')
      }
    }

    function logout() {
      toggleSideBar()
      Swal.fire({
        icon: 'info',
        title: 'apa anda yakin ingin keluar ?',
        showDenyButton: true,
        confirmButtonText: 'Ya, saya yakin',
        denyButtonText: `Batalkan`,
      }).then((result) => {
        const loader = $loading.show()
        if (result.isConfirmed) {
          let ip_address = ip.value
          store
            .dispatch('auth/logout', {
              ip_address,
            })
            .then(() => {
              toast.success('berhasil logout!')
              loader.hide()
              router.push({ name: 'login' })
              return
            })
            .catch(() => {
              toast.error('internal server error!')
              loader.hide()
              return
            })
        } else if (result.isDenied) {
          loader.hide()
          // Swal.fire('Changes are not saved', '', 'info')
        }
      })
    }

    onMounted(() => {
      data.route = route.name
    })

    return {
      logout,
      toggleSideBar,
      data,
      menu,
      profile,
      logged,
    }
  },
}
</script>
